import ScrollReveal from 'scrollreveal';
import DynamicFontSizer from '../../lib/DynamicFontSizer';

export default {
	_selector    : '[data-scroll-reveal]',
	_elements    : null,
	_scrollReveal: null,
	init() {
		this._elements = document.querySelectorAll(this._selector);
		if (!this._elements.length) {
			return;
		}
		this._scrollReveal = new ScrollReveal();
		this._scrollReveal.reveal(this._selector, {
			distance    : '32px',
			beforeReveal: el => {
				DynamicFontSizer.adjust(el);
			}
		});
	}
};